import store from '@/store';
export default {
  getFactoryPreUrl() {
    const currentFactory = store.state.app.factoryId;
    return `factory/${currentFactory}`;
  },
  // getFormatedFiltersValue(filterFields, filtersValue) {
  //   const _filtersValue = {}

  //   for (const fieldKey in filterFields) {
  //     const field = filterFields[fieldKey]
  //     const value = filtersValue[fieldKey]
  //     if(!value){
  //       continue
  //     }
  //     if (field.type == 'system_subclass') {
  //       _filtersValue[fieldKey] = value.join()
  //     } else if (field.type == 'date_range') {
  //       _filtersValue.time_field = filtersValue.time_field
  //       _filtersValue.end_time = value.end_time
  //       _filtersValue.start_time = value.start_time
  //     } else {
  //       _filtersValue[fieldKey] = value
  //     }
  //   }
  //   return _filtersValue
  // },
};
